module.exports = flarum.core.compat['components/NotificationGrid'];